const acc = document.getElementsByClassName('accordion');

for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener('click', function () {
    this.classList.toggle('active');
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });
}

if (window.innerWidth < 768) {
  $('.disclosure__button').click(function () {
    $(this)
      .parent('.disclosure-list__item')
      .parent('.mobile-menu__disclosure')
      .hide();
    $(this)
      .parent('.disclosure-list__item')
      .parent('.mobile-menu__disclosure')
      .siblings('.parent-link--false')
      .removeClass('active');
  });
}
//         if (window.innerWidth < 768) {
// document.querySelector('.mini_cart').addEventListener('click', function(event){

//   document.body.classList.add('blocked-scroll');
//   event.preventDefault();
//   document.querySelectorAll('.cart-container').classList.add('.active_link');
//   document.querySelectorAll('.dropdown_link').classList.remove('.active_link');

// });
//         }

$('.back-btn').click(function () {
  $(this).parent().slideToggle();
  $(this)
    .parents('.sublink')
    .find('.parent-link--true .active')
    .removeClass('active');
});
$('.currency-back-btn').click(function () {
  $(this).parent().slideToggle();
  $(this)
    .parents('.sublink')
    .find('.parent-link--false.active')
    .removeClass('active');
});

// $(document).on('click','.swatch-element.available',function(){
$(document).on('click', '.swatch-element.available', function () {
  // if ($(this).closest('.swatch').hasClass('show-size-var')) {
  //   $(this).parent().append('<div class="collection-added">Added!</div>');
  // }

  var $this = $(this);

  $('.getSelectedId').val($($this).data('id'));
  if ($this.parents('form').find('.add_to_cart').hasClass('trigger-click')) {
  } else {
    $this.parents('form').find('.add_to_cart').click();
    $('.collection-added').remove();
  }
});
